export default __webpack_public_path__ + "static/media/element_90.8b7120d0.webp";